import gql from 'graphql-tag'

export default gql`
query getOfferGroupUsageCount($groupIndex: Int!) {
	cashAssist {
		getOfferGroupUsageCount(groupIndex: $groupIndex)
	}
}`
